import { formatTwigs, getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import PointIcon from '../../../../assets/plant-icon.svg';

const ReputationNotification = ({ notification }) => {
  const meta = getMeta(notification);
  const twigs = formatTwigs(meta.twigsAmount);
  const entityType = meta.twigsAwardEntityType || 'article';

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={PointIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> awarded you </span>
          <span className="font-bold text-growth-green">{twigs} Twigs</span>
          <span> on your </span>
          <span className="font-bold text-growth-green">{entityType}</span>
        </p>

        {meta.articleTitle && (
          <p className="text-sm font-bold text-growth-green-900 mt-1">
            &ldquo;{meta.articleTitle}&rdquo;
          </p>
        )}
      </div>
    </div>
  );
};

export default ReputationNotification;
